import { Spinner } from "react-bootstrap";
import React from "react";

type Props = {
  size?: "sm";
};

function Preloader(props: Props) {
  return <Spinner size={props.size} animation={`border`} />;
}

export default Preloader;
